import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@mui/material';

import { selectUserToken } from 'main/store/common/selectors';
import { selectScheduleDialogData } from 'main/store/schedule/selectors';
import { actions } from 'main/store/schedule/reducer';
import { addEvent } from 'main/utils/rest-apis/events';

export const AddButton = () => {
    const dispatch = useDispatch();
    const event = useSelector(selectScheduleDialogData);
    const token = useSelector(selectUserToken)!;

    const handleClick = useCallback(async () => {
        if (event) {
            const newEvent = await addEvent(event, token);
            dispatch(actions.addEvent(newEvent));
        }
    }, [event, token, dispatch]);

    return (
        <Button onClick={handleClick}>追加</Button>
    )
}
